module.exports = __webpack_public_path__ + "images/cd74a72083a300a45d076e143a739f1e.svg";